import React, { Component } from 'react';
import { ENGLISH, ARABIC } from '../../shared/supportedLanguages';
import "./WelcomeScreenComponent.css";
import welcomeSlogan from '../../assets/images/welcomeSlogan.png';
import logoImg from '../../assets/images/logoImg.png';

export default class WelcomeScreen extends Component {

    constructor(props) {
        super(props);
        window.addEventListener("startChatbotEnglish", () => this.handleStartChatBotEnglish(), false);
        window.addEventListener("startChatbotArabic", () => this.handleStartChatBotArabic(), false);
    }
   
    componentDidMount() { }

    handleStartChatBotEnglish() {
        this.props.startBotWithLanguage(ENGLISH);
    }

    handleStartChatBotArabic () {
        this.props.startBotWithLanguage(ARABIC);
    }
    // Handel Start With Lang 
    handelStartWithLang = (lang) => {
        debugger;
        if (lang == ARABIC) {
            localStorage.setItem('botLang',ARABIC);
            this.handleStartChatBotArabic();
            this.props.onOpenChat(lang);
        }
        else {
            // alert('Lang is : ' + lang);
            localStorage.setItem('botLang',ENGLISH);
            this.handleStartChatBotEnglish(); 
            this.props.onOpenChat(lang);
            // alert('End onOpenChat : ' + lang);
        }
        // return  this.props.onOpenChat(lang);
    }

    render() {
        return (
        //     <iframe id="welcomeScreen" style={{height:'100%', width:'100%'}} marginWidth="0" marginHeight="0" scrolling="No"
        //         frameBorder="0" hspace="0" vspace="0" title="welcomeScreen" src={'./WelcomeScreen.html'} sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-forms">
        // </iframe>
            <div className="welcome">
                <div className="logo">
                    <img src={logoImg} width="125" height="130"/>
                </div>
                <div className="text">
                    <p>
                        Hi, I’m <strong>Maryam!</strong> <br/>
                        Your friendly assistant from Ministry of Health and Prevention.<br/><br/>
                        Please type your question and in case I didn’t understand you, you will be transferred to our customer happiness agent.
                    </p>
                    {/* <p className="text-center">Sincerely Yours,Maryam!</p> */}
                    <div className="image">
                        <img src={welcomeSlogan} />
                    </div>
                </div>
                <div className="actions">
                    {/* <button onClick={(e)=> this.handelStartWithLang(e, ENGLISH)}>Let's Talk</button>
                    <button onClick={(e)=> this.handelStartWithLang(e, ARABIC)}>دعنا نتحدث</button> */}
                    <button onClick={() => this.handelStartWithLang(ENGLISH)}>Let's Talk</button>
                    <button onClick={()=> this.handelStartWithLang(ARABIC)}>دعنا نتحدث</button>
                </div>
                <div className="version">
                    <p>{process.env.REACT_APP_VERSION}</p>
                </div>
            </div>
        )
    }
}